import { CheckCircleFilled, InfoCircleFilled } from '@ant-design/icons'
import { displayValues } from '@components/Admin/Location/Cards/components/CustomHeaderTooltips'
import { ErrorList } from '@components/Admin/Location/Cards/components/ResultsModal/ErrorList'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Modal, Tooltip } from 'antd'
import React, { useMemo } from 'react'

export const ResultsModal = ({ setResultsData, resultsData, selectedProperty, setSelectedProperty }) => {
  const errorsList = useMemo(() => {
    if (!resultsData.errors?.length) return []
    return resultsData.errors?.reduce((acc, error) => {
      if (acc[error.error]) {
        acc[error.error].push(error)
      } else {
        acc[error.error] = [error]
      }
      return acc
    }, {})
  }, [resultsData?.errors])
  const tooltip = useMemo(() => {
    if (!selectedProperty)
      return displayValues.filter((v) => v.field === 'activity')?.[0]?.value(true) || 'No tooltip available'

    return displayValues.filter((v) => v.field === selectedProperty)?.[0]?.value(true) || 'No tooltip available'
  }, [selectedProperty])

  const title = (
    <Horizontal className={'full-height-width'} verticalCenter>
      <Texto>Terminal Card Confirmation </Texto>
      <Tooltip
        title={
          'Certification Triggers updated from Manual to Automatic will update the Certification date after the driver completes a load'
        }
      >
        <InfoCircleFilled className={'ml-2'} />
      </Tooltip>
    </Horizontal>
  )

  return (
    <Modal
      className={'update-results-modal'}
      width={600}
      title={title}
      visible={true}
      footer={
        <Horizontal verticalCenter justifyContent={'flex-end'}>
          <GraviButton
            buttonText={'Dismiss'}
            onClick={() => {
              setResultsData(null)
              setSelectedProperty(null)
            }}
            className={'square-ish'}
          />
        </Horizontal>
      }
      onCancel={() => {
        setResultsData(null)
        setSelectedProperty(null)
      }}
    >
      <>
        <Horizontal className={'full-height-width border-bottom'} verticalCenter>
          <Vertical flex={0.1} verticalCenter />
          <Horizontal flex={1} verticalCenter className={'py-2'}>
            <Texto category={'h4'}>
              <CheckCircleFilled style={{ color: 'var(--theme-success)' }} className={'mr-2'} />
              Successfully Updated ({resultsData.success})
            </Texto>
          </Horizontal>
        </Horizontal>

        {Object.keys(errorsList).length > 0 && <ErrorList errors={errorsList} tooltip={tooltip} />}
      </>
    </Modal>
  )
}
